import styled from "styled-components";

interface ISearchProps{
    isOpen: boolean
}

export const Container = styled.div `
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    @media(min-width: 768px) {
        margin-bottom: 8px;
    }  
` 
export const ContainerSearch = styled.aside<ISearchProps>`
    input:-webkit-autofill,
    input:-webkit-autofill:hover, 
    input:-webkit-autofill:focus, 
    input:-webkit-autofill:active{
        -webkit-box-shadow: 0 0 0 30px #363435 inset !important;
        box-shadow: 0 0 0 30px #363435 inset;
        -webkit-text-fill-color: #BDBDBD !important;
    }

    position: fixed;
    top: 100px;
    bottom: 0;
    right: 0;
    height: 100vh;
    display: ${prop => prop.isOpen? 'flex' : 'none'};
    flex-direction: column;
    width: 100%;
    background-color: #363435;
    z-index: 3;

    .svgSearch{
        width: 34px;
        height: 34px; 
        align-self: center; 
        margin-left: 30px;
    }

    .svgExit{
        width: 100%; 
        height: 100%;
    }

    @media(min-width:768px) {
        top: 57px;
        height: 90px;
    }

`
export const Button = styled.button`
    border: none; 
    background-color: transparent;
    width: 34px; 
    height: 20px; 
    align-self: center; 
    margin-right: 20px;
`

export const Row = styled.hr` 
    background-color: #757575;
    height: 1px; 
    border: none; 

    @media(min-width:768px) {
        background-color: #FFFFFF;
    }
`
